
import React, { useState, useEffect } from "react";

const AuctionTimeLeft = (
    listingDetails,
    until,
) => {

   const [lastUntil, setLastUntil] = useState(listingDetails.until + new Date().getTime());
       const [timeRemaining, setTimeRemaining] = useState(0);
   
       useEffect(() => {
           const countdownInterval = setInterval(() => {
               const currentTime = new Date().getTime();
               const eventTime = lastUntil;
               let remainingTime = eventTime - currentTime;
   
               setTimeRemaining(remainingTime);
           }, 1000);
   
       }, [timeRemaining]);
   
   
       const formatTime = (time) => {
           const seconds = Math.floor((time / 1000) % 60);
           const minutes = Math.floor((time / (1000 * 60)) % 60);
           const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
           const days = Math.floor(time / (1000 * 60 * 60 * 24));
   
           return (
   
                 <div className="timer-bid"
           style={{
             fontSize: 12,
           
           }}>
       
           <p className="timerFont">{days.toString().padStart(2, "0") + ' Days'}
           <span className="timerFont"> : </span>
           <span className="timerFont"> {hours.toString().padStart(2, "0") + ' Hrs'}</span>
            <span className="timerFont"> : </span>
           <span className="timerFont">{minutes.toString().padStart(2, "0") + ' Mins'}</span>
            <span className="timerFont"> : </span>
           <span className="timerFont">{seconds.toString().padStart(2, "0") + ' Secs'}</span>
         </p>
         
         {/* <p
           style={{
             fontSize: 10,
             fontWeight:'bold',
             width: "100px",
             display: "flex",
             justifyContent: "space-around",
           }}
         > 
           DAYS {" "}<span className="ml-4 pr10 pl10">HRS {" "}</span>
           <span className="ml-2 pr10">MINS {" "}</span> <span className="ml-2 pr10">SECS {" "}</span>{" "}
         </p> */}
   
         </div>
       
           );
       };
   
       const getStatus = () => {
         if(listingDetails?.listingDetails?.listingStatusDetail === 'UNDERREVIEW'){
           return 'Under Review'
         }else if(listingDetails?.listingDetails?.listingStatusDetail === 'SUCCESSFUL' && listingDetails?.listingDetails?.listingStatus === 'Closed'){
           return "Action Ended"
         }else{
           return ""
         }
       }
   
    
       return(
         <div className="countdown-timer-container center mob-center">
               {formatTime(timeRemaining)}
           </div>
       )
      
     
   
  

};

export default AuctionTimeLeft;